export class RateNoteTranslation {
  constructor(
    public locale: string,
    public externalNote: string,
  ) {}
}
